import { call, put, takeLatest } from 'redux-saga/effects';
import get from 'lodash/get';
import { GET_CONTENT, NAVIGATION_LINK_CONTENT, GUEST_CONTENT_CHECKOUT, GET_GUEST_CONTENT_SUCCESS, GET_GUEST_CONTENT_FAILURE, FIND_A_KFC, FIND_A_KFC_SUCCESS, FIND_A_KFC_ERROR, DYNAMIC_MENU_ALERT_CONTENT, DYNAMIC_MENU_ALERT_SUCCESS, DYNAMIC_MENU_ALERT_ERROR, } from '../constants';
import { getContentApiError, getContentApiSuccess, getNavigationLinkContentError, getNavigationLinkContentSuccess, } from '../redux/Actions/ContentAction';
import { appendLocaleInCMSRequest } from '../network';
const parseContentResponse = (payload, response) => {
    let result = { homeContentfulResp: null, seoStructureData: null, smartBanner: null };
    //if logged in and localized (Store selected)
    result.rootSysId = response.items?.length ? response.items[0]?.sys?.id ?? null : null;
    if (payload.userParams.loggedIn && payload.userParams.localized) {
        result = {
            ...result,
            homeContentfulResp: response.items[0].fields.localizedAuthenticated,
        };
    }
    //  if logged in and non-localized (Store not selected)
    else if (payload.userParams.loggedIn && !payload.userParams.localized) {
        result = {
            ...result,
            homeContentfulResp: response.items[0].fields.nonlocalizedauthenticated,
        };
    }
    //if not logged in and non-localized (Store not selected)
    else if (!payload.userParams.loggedIn && !payload.userParams.localized) {
        result = {
            ...result,
            homeContentfulResp: response.items[0].fields.nonlocalizedguest,
        };
    }
    else if (!payload.userParams.loggedIn && payload.userParams.localized) {
        result = {
            ...result,
            homeContentfulResp: response.items[0].fields.localizedguest,
        };
    }
    const smartBanner = get(response, 'items[0].fields.smartBanner');
    const bannerData = get(smartBanner, 'fields');
    if (bannerData) {
        result = {
            ...result,
            smartBanner: bannerData,
        };
    }
    const seoStructureData = response.items?.[0]?.fields?.seoStructureData;
    const seoData = seoStructureData?.fields;
    if (seoData) {
        result = {
            ...result,
            seoStructureData: seoData,
        };
    }
    return result;
};
export function* contentCall(data) {
    try {
        const { payload } = data;
        const response = yield call(payload.object.getEntries, appendLocaleInCMSRequest(payload.contentFull));
        if (response) {
            const result = parseContentResponse(payload, response);
            yield put(getContentApiSuccess(result));
        }
        else {
            yield put(getContentApiError());
        }
    }
    catch (error) {
        yield put(getContentApiError());
    }
}
export function* navigationLinkContentRequest(data) {
    try {
        const { payload } = data;
        const response = yield call(payload.cmsClient.getEntries, appendLocaleInCMSRequest(payload.query));
        if (response) {
            const result = {
                fields: response?.items?.map((item) => item.fields),
            };
            yield put(getNavigationLinkContentSuccess(result));
        }
        else {
            yield put(getNavigationLinkContentError());
        }
    }
    catch (error) {
        yield put(getNavigationLinkContentError());
    }
}
export function* contentSaga() {
    yield takeLatest(GET_CONTENT, contentCall);
}
export function* navigationLinkContentSaga() {
    yield takeLatest(NAVIGATION_LINK_CONTENT.GET_CONTENT, navigationLinkContentRequest);
}
export function* getGuestContentCall(data) {
    try {
        const { payload } = data;
        const response = yield call(payload.contentful.getEntries, appendLocaleInCMSRequest(payload.query));
        if (response) {
            yield put({
                type: GET_GUEST_CONTENT_SUCCESS,
                response,
            });
        }
        else {
            yield put({
                type: GET_GUEST_CONTENT_FAILURE,
            });
        }
    }
    catch (error) {
        yield put({
            type: GET_GUEST_CONTENT_FAILURE,
        });
    }
}
export function* getGuestContentSaga() {
    yield takeLatest(GUEST_CONTENT_CHECKOUT, getGuestContentCall);
}
export function* getfindAKFCContentCall(data) {
    try {
        let result = {};
        const { payload } = data;
        const response = yield call(payload.object.getEntries, appendLocaleInCMSRequest(payload.contentFull));
        if (response && response !== undefined && response !== null) {
            result = {
                ...result,
                findAKFCResp: response,
            };
            yield put({
                type: FIND_A_KFC_SUCCESS,
                response: result,
            });
        }
        else {
            yield put({
                type: FIND_A_KFC_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: FIND_A_KFC_ERROR,
        });
    }
}
export function* findAKFCContentSaga() {
    yield takeLatest(FIND_A_KFC, getfindAKFCContentCall);
}
export function* getDynMenuAlertContent(data) {
    try {
        let result = {};
        const { payload } = data;
        const response = yield call(payload.object.getEntries, payload.contentFull);
        if (response) {
            result = {
                ...result,
                ...response,
            };
            yield put({
                type: DYNAMIC_MENU_ALERT_SUCCESS,
                response: result,
            });
        }
        else {
            yield put({
                type: DYNAMIC_MENU_ALERT_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: DYNAMIC_MENU_ALERT_ERROR,
        });
    }
}
export function* getDynMenuAlert() {
    yield takeLatest(DYNAMIC_MENU_ALERT_CONTENT, getDynMenuAlertContent);
}
